import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=e0b965e8&"
import script from "./Collection.vue?vue&type=script&lang=js&"
export * from "./Collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0b965e8')) {
      api.createRecord('e0b965e8', component.options)
    } else {
      api.reload('e0b965e8', component.options)
    }
    module.hot.accept("./Collection.vue?vue&type=template&id=e0b965e8&", function () {
      api.rerender('e0b965e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/Collection/Collection.vue"
export default component.exports